import { getToken } from 'firebase/messaging'
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDKqFrBAFUvcAIKMfiJ5KPdUw2dmtqnFgM",
  authDomain: "protokol-platform.firebaseapp.com",
  projectId: "protokol-platform",
  storageBucket: "protokol-platform.appspot.com",
  messagingSenderId: "595652017000",
  appId: "1:595652017000:web:eadedea0e1d570a1f134dd",
  measurementId: "G-G33YF1VN94"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export async function getNotificationsToken() {
  // Get registration token. Initially this makes a network call, once retrieved
  // subsequent calls to getToken will return from cache.
  return await getToken(messaging, { vapidKey: 'BBLUjss-kOlaJ2s1j12ImuiFxX3m0sK1183T6JMRzqOgGSP2OFqyn7upXz1rR-iiL35WWAa8jUoWKIz6ElgKM30' })
}